<template lang="pug">
  div.body.body-table.garbage-house-container-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent="")
              // input(type="search" placeholder="" v-model="searchModel")
            div.parameters
            div.actions-panel
              e-button-add(@click="addNewRowToTable")
              // button(v-if="role!=='guest'" type="button" @click="addNewRowToGarbageTable").actions-panel__button.btn-add.green

      div(v-if="operationType === '1'")
        e-table-editable(
        ref="garbage"
        :attributes="garbageAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :onlyOneAdd="false"
        @afterCreateRow="afterCreateGarbageRow"
        )

      div(v-if="operationType === '2'")
        e-table-editable(
        ref="house"
        :attributes="houseAttr"
        :dataUrl="houseDataUrl"
        :postUrl="housePostUrl"
        :patchUrl="housePatchUrl"
        :deleteUrl="houseDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        )

      e-modal(v-if="showGarbageModal"
      @close="showGarbageModal = false"
      @confirm="saveGarbageList()"
      title="Выбор отходообразователей"
      )
        slot
          e-table-checked-list(
          @checkedChange="garbageListUpdate($event)"
          :endpoint="endpointGarbageList"
          :earlyCheckedItems="earlyCheckedGarbage"
          :showPaginate="true"
          )

        template(slot="footer")
          div.search-result
            span Выбрано {{checkedGarbageLen}} объектов
          div
            button(
            type="button"
            @click="closeGarbageModal()"
            ).actions-filter-panel__button.standart.standart-noborder Отмена
            button(
            type="button"
            @click="saveGarbageList()"
            ).actions-filter-panel__button.standart Сохранить

</template>

<script>
  import {msnOffline} from '../../../../api/api-offline-endpoints.js'
  import {garbage, housing, msn} from '../../../../api/api-endpoints'

  const Model = (operationType) => {
    return {
      addressName: '',
      name: '',
      type: JSON.parse(JSON.stringify(operationType))
    }
  }

  export default {
    name: 'garbage-house-container-table',
    props: {
      id: null,
      tabView: null
    },
    data () {
      return {
        showGarbageModal: false,
        checkedGarbageLen: 0,
        checkedGarbage: [],
        garbageModels: {},
        operationType: null,
        search: '',
        searchModel: ''
      }
    },
    computed: {
      selectListOptions () {
        return [
          {
            id: '1',
            name: 'Отходообразователи'
          }/*,
          {
            id: '2',
            name: 'Дома'
          }*/
        ]
      },
      tableInOnlineMode () {
        return this.$route.params.id
      },
      enableOnAdd () {
        return []
      },
      garbageAttr () {
        return {
          name: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            required: true,
            placeholder: 'Начните вводить название отходообразователя',
            suggestion: {
              options: [],
              onSelect: this.onSelectGarbage,
              suggestionEndpoint: this.suggestionGarbageEndpoint,
              transformSuggestions: this.transformSuggestionsGarbage
            }
          },
          addressName: {
            label: 'Адрес',
            required: true,
            placeholder: 'Выберите отходообразователя сначала',
            disabled: true,
            validationRulePattern: '(\\.*)'
          }
        }
      },
      houseAttr () {
        return {
          name: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            required: true,
            placeholder: 'Начните вводить адрес дома',
            suggestion: {
              options: [],
              onSelect: this.onSelectHouse,
              suggestionEndpoint: this.suggestionHouseEndpoint,
              transformSuggestions: this.transformSuggestionsHouse
            }
          },
          addressName: {
            label: 'Адрес',
            required: true,
            placeholder: 'Выберите до сначала',
            disabled: true,
            validationRulePattern: '(\\.*)'
          }
        }
      },
      garbageDataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              sourceId: this.id,
              type: this.operationType
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }

          return msn.garbageHouseOperation(routeQuery)
        }
        // if new record, offline save
        return msnOffline.garbageHouseContainerTable(this.$route.name, this.operationType)
      },
      houseDataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              sourceId: this.id,
              type: this.operationType
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }

          return msn.garbageHouseOperation(routeQuery)
        }
        // if new record, offline save
        return msnOffline.garbageHouseContainerTable(this.$route.name, this.operationType)
      },
      garbageItems () {
        return this.$store.getters.readUrlEndpoint(this.garbageDataUrl)
      },
      earlyCheckedGarbage () {
        let checked = []
        if (this.garbageItems && this.garbageItems.data) {
          this.garbageItems.data.forEach(v => {
            if (v.garbage_source_id) {
              checked.push(v.garbage_source_id)
            } else if (v.msnGarbageSources) {
              v.msnGarbageSources.forEach(gs => {
                checked.push(gs.garbage_source_id)
              })
            }
          })
        }
        return {default: checked}
      }
    },
    methods: {
      afterCreateGarbageRow ({model}) {
        this.$refs.garbage.saveRow(model, -1, false)
      },
      endpointGarbageList (ctx, query = {'per-page': 50}) {
        let route = {query}
        if (ctx.q) {
          route.query.q = ctx.q
        }
        if (ctx.paginateObj) {
          route.query = Object.assign(route.query, ctx.paginateObj)
        }
        if (ctx.currentSort) {
          route.query.sort = ctx.currentSort
        }

        return {
          url: garbage.garbages(route),
          fields: {
            name: {
              label: 'Название'
            },
            address: {
              label: 'Местоположение'
            }
          }
        }
      },
      garbageListUpdate ($event) {
        console.log($event)
        let {checked, checkedLen, checkedModels} = $event
        this.checkedGarbageLen = checkedLen
        this.checkedGarbage = checked.default
        this.garbageModels = Object.assign({}, this.garbageModels, checkedModels.default)
      },
      saveGarbageList () {
        console.log('saveGarbageList')
        try {
          let earlyCheckedGarbage = this.earlyCheckedGarbage.default
          this.checkedGarbage.forEach(id => {
            // check for dublicates
            if (earlyCheckedGarbage.indexOf(id) === -1) {
              let model = new Model(this.operationType)
              if (this.garbageModels.hasOwnProperty(id)) {
                model.garbage_source_id = id
                model.name = this.$options.filters.stripHtml(this.garbageModels[id].name)
                // set space for disable reuqired error and disable palcholder
                model.addressName = this.garbageModels[id].address || ' '
                this.$refs.garbage.createRow(model)
              } else {
                throw new Error('Не удалось найти информацию об отходобразователе')
              }
            } else {
              console.log('exist ', id)
            }
          })
        } catch (e) {
          this.$e.errorBox(e)
        }
        this.closeGarbageModal()
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i] && data.data[i].address) {
            data.data[i].addressName = data.data[i].address.value || data.data[i].address.source
          } else {
            data.data[i].addressName = ''
          }
        }
        return data
      },
      onSelectHouse (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.name = copy.name
          model.addressName = copy.address
          model.house_id = copy.id
        } else {
          model.name = ''
          model.house_id = ''
        }
      },
      suggestionHouseEndpoint (ctx, q) {
        return housing.houses({query: {q, 'per-page': 50}})
      },
      transformSuggestionsHouse (ctx, response) {
        let data = response.data
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].name,
            id: data[i].id,
            address: data[i].name
          })
        }
        return options
      },
      onSelectGarbage (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.name = this.$options.filters.stripHtml(copy.name)
          model.garbage_id = copy.id
          model.addressName = copy.address || ' '
        } else {
          model.name = ''
          model.garbage_id = ''
          model.addressName = ''
        }
      },
      suggestionGarbageEndpoint (ctx, q) {
        return garbage.garbages(
          {
            query: {
              q,
              'per-page': 50
            }
          }
        )
      },
      transformSuggestionsGarbage (ctx, response) {
        let data = response.data
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].name,
            id: data[i].id,
            address: data[i].address
          })
        }
        return options
      },
      housePostUrl (context, model) {
        return null
      },
      housePatchUrl (context, model) {
        return null
      },
      houseDeleteUrl (context, model) {
        return null
      },
      garbagePostUrl (context, model) {
        return msn.garbageHouseOperationPost(this.id)
      },
      garbagePatchUrl (context, model) {
        return msn.garbageHouseOperationPath(this.id, model.id)
      },
      garbageDeleteUrl (context, model) {
        return msn.garbageHouseOperationDelete(this.id, model.id)
      },
      closeGarbageModal () {
        this.showGarbageModal = false
        this.checkedGarbageLen = 0
      },
      openGarbageModal () {
        this.showGarbageModal = true
      },
      addNewRowToTable () {
        if (this.operationType === '1') {
          this.openGarbageModal()
          // this.$refs.garbage.createRow(new Model())
        } else if (this.operationType === '2') {
          this.$refs.house.createRow(new Model(this.operationType))
        }
      }
    }
  }
</script>

<style>
  .garbage-house-container-table .e-modal .actions-filter-panel__button{
    min-width: 100px;
  }
  .garbage-house-container-table .modal {
    width: 40%!important;
    min-width: unset!important;
    max-width: unset!important;
  }
  .garbage-house-container-table .modal .checked{
    display: inline-block!important;
  }
</style>
